import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Get the API base URL.
 * - In development/preview: Uses REACT_APP_BACKEND_URL from .env
 * - In production/live: Uses relative URL (empty string) which routes through ingress
 * 
 * This allows the same build to work in both preview and live deployments.
 */
export function getApiUrl() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
  return `${backendUrl}/api`;
}

// Export for backward compatibility
export const API_URL = getApiUrl();
